import { Message } from "postcss";
import { FileMessage } from "./FileMessage";

export class ChatRoom {
  chatRoomId: string;
  username: string;
  messages: (Message|FileMessage)[];
  isSessionActive: boolean;
  unreadMessageCount: number;
  isConference: boolean;
  isGroup: boolean;
  isAgent: boolean;
  type: string;
  isCreator: boolean | null = false;
  admin: string | null = null;
  participants: string[] = [];


  constructor(
    chatRoomId: string,
    username: string,
    messages: (Message | FileMessage)[],
    type: string,
    isSessionActive: boolean = true,
    unreadMessageCount: number = 0,
    isConference: boolean = false,
    isGroup: boolean = false,
    isAgent: boolean = false,
    isCreator: boolean = false,
    admin: string | null = null,
    participants: string[] = []
  ) {
    this.chatRoomId = chatRoomId;
    this.username = username;
    this.messages = messages;
    this.type = type;
    this.isSessionActive = isSessionActive;
    this.unreadMessageCount = unreadMessageCount;
    this.isConference = isConference;
    this.isGroup = isGroup;
    this.isAgent = isAgent;
    this.isCreator = isCreator;
    this.admin = admin;
    this.participants = participants;
  }
  

  toMap(): { [key: string]: any } {
    return {
      chatRoomId: this.chatRoomId,
      username: this.username,
      messages: this.messages.map((msg) => msg.toMap()), 
      type: this.type,
      isSessionActive: this.isSessionActive,
      unreadMessageCount: this.unreadMessageCount,
      isConference: this.isConference,
      isGroup: this.isGroup,
      isAgent: this.isAgent,
      isCreator: this.isCreator,
      admin: this.admin,
      participants: this.participants,
    };
  }
}
